module.exports = __webpack_public_path__ + "static/img/loading.94fa1b1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 3